import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

function SsnInputComponent(props) {
  // other is required to pass the input down
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format="#########"
      mask=""
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange(values.value);
      }}
      isNumericString
    />
  );
}

SsnInputComponent.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SsnInputComponent;
